import React from "react";
import { useSelector } from "react-redux";
import classes from "./ItemBlock.module.css";

const ItemBlock = ({ bgColor, height, title, text, media, icon, children, className = "" }) => {

  const { texts } = useSelector(state => state.translate);

  return (
    <div className={`${classes.wrapper} ${className}`} style={{ backgroundColor: bgColor, height: height }}>
      {(title || icon) && (
        <div className={classes.titleContainer}>
          {title && <h3 className={classes.Title}>{texts[title] || title}</h3>}
          {icon && <div className={classes.iconWrapper}>{icon}</div>}
        </div>
      )}
      <div className={classes.Content}>
        {children && children}
      </div>
    </div>
  );
};

export default ItemBlock;
